// A helper function to fetch Scenario Data

import { useAPI } from "/src/hooks/useAPI";

export async function fetchProgram(brand, authToken, trainingprogram_id) {
    const {callAPI} = useAPI();
    try {
        const response = await callAPI(`trainingprograms?trainingprogram_id=${trainingprogram_id}`, {
            token: authToken,
        });

        return response;
    } catch (err) {
        console.error('Error fetching scenario:', err.message);
        return null;
    }
}
